var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.healthyHabits.table.data.items &&
    _vm.$store.state.healthyHabits.table.data.items.length > 0 &&
    !_vm.$store.state.healthyHabits.form.editing
      ? _c(
          "div",
          [
            _c("h3", { staticClass: "type-habit-title my-4" }, [
              _vm._v(_vm._s(_vm.$t("selectHabitType")))
            ]),
            _vm._v(" "),
            _c("healthy-habits-predefined", {
              attrs: { showingInForm: "" },
              on: {
                predefinedHabitSelected: function($event) {
                  return _vm.loadPredefinedHabit()
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.$store.state.healthyHabits.form.editing
      ? _c("div", [
          _c("h3", { staticClass: "type-habit-title my-4" }, [
            _vm._v(
              _vm._s(
                _vm.$store.state.healthyHabits.table.data.items &&
                  _vm.$store.state.healthyHabits.table.data.items.length > 0
                  ? _vm.$t("createOwnHabit")
                  : _vm.$t("selectHabitType")
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "type-habit-options-box" },
            [
              _c(
                "base-card",
                {
                  class: {
                    "type-habit-option-selected":
                      _vm.healthyHabitsData.measurable === true,
                    "type-habit-card": true,
                    "mr-3": true
                  },
                  staticStyle: { "z-index": "1" },
                  attrs: { name: "measurable-option" },
                  on: {
                    click: function($event) {
                      _vm.healthyHabitTypeSelected(true)
                      _vm.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null
                    }
                  }
                },
                [
                  _c("span", { staticClass: "card-form-content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("measurable")))]),
                    _c("br"),
                    _c("span", { staticClass: "frequency-options-examples" }, [
                      _vm._v(_vm._s(_vm.$t("measurableExamples")))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "base-card",
                {
                  class: {
                    "type-habit-option-selected":
                      _vm.healthyHabitsData.measurable === false,
                    "type-habit-card": true
                  },
                  attrs: { name: "no-measurable-option" },
                  on: {
                    click: function($event) {
                      _vm.healthyHabitTypeSelected(false)
                      _vm.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null
                    }
                  }
                },
                [
                  _c("span", { staticClass: "card-form-content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("notmeasurable")))]),
                    _c("br"),
                    _c("span", { staticClass: "frequency-options-examples" }, [
                      _vm._v(_vm._s(_vm.$t("notMeasurableExamples")))
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.healthyHabitsData.measurable != null
      ? _c(
          "div",
          [
            _c(
              "base-card",
              {
                class: {
                  row: true,
                  "type-habit-form-box": true,
                  "width-95": !this.inModal
                }
              },
              [
                _c(
                  "b-row",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "margin-bottom-form px-2",
                        attrs: { cols: "12" }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("color")) + ": "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.healthyHabitsData.color,
                              expression: "healthyHabitsData.color"
                            }
                          ],
                          staticClass: "cursor-pointer",
                          attrs: { type: "color" },
                          domProps: { value: _vm.healthyHabitsData.color },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.healthyHabitsData,
                                "color",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.state.description,
                            placeholder: _vm.healthyHabitsData.measurable
                              ? _vm.$t("nameFormMeasurablePlaceholder")
                              : _vm.$t("nameFormPlaceholder")
                          },
                          on: {
                            blur: function($event) {
                              _vm.state.description = _vm.healthyHabitsData
                                .description
                                ? true
                                : false
                            }
                          },
                          model: {
                            value: _vm.healthyHabitsData.description,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.healthyHabitsData,
                                "description",
                                $$v
                              )
                            },
                            expression: "healthyHabitsData.description"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.healthyHabitsData.measurable
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.state.goal,
                                readonly: _vm.isMultiUser,
                                name: _vm.isMultiUser
                                  ? "readonlymultiuser"
                                  : "",
                                type: _vm.isMultiUser ? "text" : "number",
                                min: 0,
                                step: 1,
                                placeholder: _vm.$t("goalFormPlaceholder")
                              },
                              on: {
                                blur: function($event) {
                                  _vm.state.goal =
                                    _vm.healthyHabitsData.goal > 0
                                }
                              },
                              model: {
                                value: _vm.healthyHabitsData.goal,
                                callback: function($$v) {
                                  _vm.$set(_vm.healthyHabitsData, "goal", $$v)
                                },
                                expression: "healthyHabitsData.goal"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.healthyHabitsData.measurable
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.state.measureUnit,
                                readonly: _vm.isMultiUser,
                                name: _vm.isMultiUser
                                  ? "readonlymultiuser"
                                  : "",
                                placeholder: _vm.$t("UnitFormPlaceholder")
                              },
                              on: {
                                blur: function($event) {
                                  _vm.state.measureUnit = _vm.healthyHabitsData
                                    .measureUnit
                                    ? true
                                    : false
                                }
                              },
                              model: {
                                value: _vm.healthyHabitsData.measureUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.healthyHabitsData,
                                    "measureUnit",
                                    $$v
                                  )
                                },
                                expression: "healthyHabitsData.measureUnit"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "px-2",
                        attrs: { cols: "12" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.isMultiUser
                              ? (_vm.showFrequencyModal =
                                  _vm.showFrequencyModal)
                              : (_vm.showFrequencyModal = true)
                          }
                        }
                      },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.state.goalFrequencyId,
                            name: _vm.isMultiUser ? "readonlymultiuser" : "",
                            readonly: "",
                            placeholder: _vm.$t("frequency")
                          },
                          model: {
                            value: _vm.frequencyText,
                            callback: function($$v) {
                              _vm.frequencyText = $$v
                            },
                            expression: "frequencyText"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-input-group",
                          {
                            staticClass: "reminder-input-form",
                            staticStyle: { "margin-bottom": "1.5rem" }
                          },
                          [
                            _c(
                              "b-input-group-prepend",
                              [
                                _c("b-input-group-text", [_c("b-icon-bell")], 1)
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "reminder-container form-control"
                              },
                              [
                                _c("vue-clock-picker", {
                                  attrs: {
                                    id: "reminder-clock-selector",
                                    "active-color": _vm.healthyHabitsData.color,
                                    "done-text": _vm.$t("save"),
                                    "cancel-text": _vm.$t("reset"),
                                    "input-class": "clock-selector-input",
                                    placeholder:
                                      _vm.$t("reminder") +
                                      " " +
                                      _vm.$t("optional")
                                  },
                                  on: {
                                    timeset: function($event) {
                                      _vm.showReminderDaysInput = true
                                    },
                                    beforeOpen: _vm.setDefaultTime,
                                    cancel: _vm.resetReminder
                                  },
                                  model: {
                                    value: _vm.healthyHabitsData.reminder,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.healthyHabitsData,
                                        "reminder",
                                        $$v
                                      )
                                    },
                                    expression: "healthyHabitsData.reminder"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-input-group-text",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: { click: _vm.resetReminder }
                                  },
                                  [_c("b-icon-trash")],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showReminderDaysInput
                      ? _c(
                          "b-col",
                          {
                            staticClass: "px-2",
                            attrs: { cols: "12" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.showReminderDaysModal = true
                              }
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              {
                                staticClass: "reminder-input-form",
                                staticStyle: { "margin-bottom": "1.5rem" }
                              },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  [
                                    _c(
                                      "b-input-group-text",
                                      [_c("b-icon-bell")],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    readonly: "",
                                    placeholder: _vm.$t("reminderDays")
                                  },
                                  model: {
                                    value: _vm.reminderDaysText,
                                    callback: function($$v) {
                                      _vm.reminderDaysText = $$v
                                    },
                                    expression: "reminderDaysText"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c("base-textarea", {
                          attrs: {
                            noResize: "",
                            maxRows: 10,
                            rows: 1,
                            state: _vm.state.notes,
                            placeholder:
                              _vm.$t("notes") + " " + _vm.$t("optional"),
                            readOnly: !!_vm.$route.params.t
                          },
                          on: {
                            blur: function($event) {
                              _vm.state.notes = _vm.healthyHabitsData.notes
                                ? true
                                : null
                            }
                          },
                          model: {
                            value: _vm.healthyHabitsData.notes,
                            callback: function($$v) {
                              _vm.$set(_vm.healthyHabitsData, "notes", $$v)
                            },
                            expression: "healthyHabitsData.notes"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.$store.state.healthyHabits.form.editing
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "form-group",
                                attrs: { switch: "" },
                                on: { change: _vm.switchInviteMultiUser },
                                model: {
                                  value:
                                    _vm.$store.state.healthyHabits.form
                                      .multiUser,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$store.state.healthyHabits.form,
                                      "multiUser",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$store.state.healthyHabits.form.multiUser"
                                }
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("invitePatientsMultiUser")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-icon-question-circle", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    },
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.click",
                                      value: _vm.$t("inviteMultiUserInfo"),
                                      expression: "$t('inviteMultiUserInfo')",
                                      modifiers: { click: true }
                                    }
                                  ],
                                  attrs: {
                                    title: _vm.$t("inviteMultiUserInfo")
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _vm.$store.state.healthyHabits.form.multiUser
                          ? _c("v-select", {
                              attrs: {
                                multiple: "",
                                taggable: "",
                                placeholder: _vm.$t("typeUserEmailsOrPhones"),
                                label: "name"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "no-options",
                                    fn: function() {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "typePatientEmailOrPhoneAdvice"
                                              )
                                            ) + "(⏎)"
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3185750296
                              ),
                              model: {
                                value:
                                  _vm.healthyHabitsData
                                    .multiUsersEmailsOrPhones,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.healthyHabitsData,
                                    "multiUsersEmailsOrPhones",
                                    $$v
                                  )
                                },
                                expression:
                                  "healthyHabitsData.multiUsersEmailsOrPhones"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "base-button",
                          {
                            staticClass: "mr-1 my-1",
                            on: {
                              click: function($event) {
                                return _vm.sendData()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("save")))]
                        ),
                        _c(
                          "base-button",
                          {
                            attrs: { gray: "" },
                            on: {
                              click: function($event) {
                                return _vm.cancel()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("back")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-modal",
              {
                attrs: {
                  noCloseOnBackdrop: "",
                  noCloseOnScape: "",
                  hideClose: "",
                  titleAlignLeft: "",
                  value: _vm.showFrequencyModal,
                  title: _vm.$t("selectAnOption")
                },
                on: {
                  hide: function($event) {
                    _vm.showFrequencyModal = false
                  }
                }
              },
              [
                _c("b-form-group", {
                  class: {
                    "no-margin-bottom": !_vm.healthyHabitsData.measurable
                  },
                  attrs: { label: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var ariaDescribedby = ref.ariaDescribedby
                          return [
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 1
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("daily")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 2
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("weekly")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 3
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("monthly")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 1
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _vm._v(_vm._s(_vm.$t("each")) + " "),
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 90
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 1
                                        }
                                      },
                                      model: {
                                        value: _vm.goalDays,
                                        callback: function($$v) {
                                          _vm.goalDays = $$v
                                        },
                                        expression: "goalDays"
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(_vm.$t("days")) + " "),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 90",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 90`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 90"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 2
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 6
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 2
                                        }
                                      },
                                      model: {
                                        value: _vm.goalWeek,
                                        callback: function($$v) {
                                          _vm.goalWeek = $$v
                                        },
                                        expression: "goalWeek"
                                      }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("timesToWeek")) + " "
                                    ),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 6",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 6`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 6"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 3
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 29
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 3
                                        }
                                      },
                                      model: {
                                        value: _vm.goalMonth,
                                        callback: function($$v) {
                                          _vm.goalMonth = $$v
                                        },
                                        expression: "goalMonth"
                                      }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("timesToMonth")) + " "
                                    ),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 29",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 29`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 29"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1253626556
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("base-button", { on: { click: _vm.saveFrequency } }, [
                      _vm._v(_vm._s(_vm.$t("save")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-modal",
              {
                attrs: {
                  noCloseOnBackdrop: "",
                  noCloseOnScape: "",
                  hideClose: "",
                  titleAlignLeft: "",
                  value: _vm.showReminderDaysModal,
                  title: _vm.$t("selectOneMoreOption")
                },
                on: {
                  hide: function($event) {
                    _vm.showReminderDaysModal = false
                  }
                }
              },
              [
                _c("b-form-checkbox-group", {
                  staticClass: "form-group",
                  attrs: {
                    stacked: _vm.showWeekDaysStacked,
                    options: _vm.weekDaysOptions,
                    "value-field": "value",
                    "text-field": "name"
                  },
                  model: {
                    value: _vm.reminderDaysArray,
                    callback: function($$v) {
                      _vm.reminderDaysArray = $$v
                    },
                    expression: "reminderDaysArray"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("base-button", { on: { click: _vm.saveReminderDays } }, [
                      _vm._v(_vm._s(_vm.$t("save")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37d6321e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d6321e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-habits/HealthyHabitsForm.vue
// module id = 1723
// module chunks = 116